<label>{{questionText}}</label>
@for (onelink of hyperlinks; track onelink) {
  <div>
    <a (click)="onLinkClicked(onelink)" target="_parent" title="{{onelink}}">Click Here</a>
  </div>
}